import {
  Button,
  Form,
  Input,
  Card,
  notification,
  Typography,
  Upload,
  Space,
  Avatar
} from 'antd'
import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { useAuthStore } from 'src/store/auth'
import { API } from 'src/API'
import axios from 'src/API/config'

import './ProfileForm.css'

const { Text } = Typography

export const ProfileForm = () => {
  const [api, contextHolder] = notification.useNotification()

  const { refreshUser, user } = useAuthStore((store) => store)

  const handleChange = async (e) => {
    const form = new FormData()
    form.append('file', e)

    const res = await axios.post(API.COMMON.avatarEndpoint, form)
    refreshUser()
  }

  const onChangeImage = (e) => {
    const reader = new FileReader(),
      files = e.target.files
    reader.onload = function () {
      handleChange(files[0])
      e.target.value = null
    }
    reader.readAsDataURL(files[0])
  }

  useEffect(() => {}, [])

  return (
    <Card
      style={{
        width: '100%'
      }}
    >
      {contextHolder}
      <Avatar src={user?.profile?.avatar?.[0]?.url} size={100} shape='square' />
      <label style={{ marginLeft: 20 }} for={'avatar'}>
        Upload avatar
      </label>
      <input
        type='file'
        id='avatar'
        onChange={onChangeImage}
        hidden
        name='avatar'
        accept='image/*'
      />
    </Card>
  )
}
export default ProfileForm
